import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { SelectedType } from '../../new-contract-large-accounts.model';

@Component({
  selector: 'app-new-contract-select-type',
  templateUrl: './new-contract-select-type.component.html',
  styleUrls: ['./new-contract-select-type.component.scss']
})
export class NewContractSelectTypeComponent implements OnInit {
  @Output() canGoNext: EventEmitter<SelectedType> = new EventEmitter();

  public selectForm: FormGroup = new FormGroup({ type: new FormControl(null) });

  ngOnInit(): void {
    this.selectForm.get('type').valueChanges.subscribe(value => {
      this.canGoNext.emit({ valid: true, value });
    });
  }
}
